import React from "react";

import {
  HorizontalCourseLogoMarquee,
  VerticalCourseLogoMarquee,
} from "../CourseLogoMarquee/CourseLogoMarquee";
import { useSvgIds } from "../../icons/useSvgIds";
import { COURSE_HEADER_ICONS } from "./courseAssets";
import { COURSE_LOGOS_DARK } from "./courseMarqueeAssets";
import useWebflowTabs from "../../utils/useWebflowTabs";
import ReachRim from "../ReachRim/ReachRim";

import "./CoursesSectionDark.css";

const META_STROKE = "#E2E8F0";

function CourseDurationIcon({ className = "course-meta-icon", ...props }) {
  const { clip } = useSvgIds("course-duration");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <g clipPath={`url(#${clip})`}>
        <path
          d="M9.99935 4.99984V9.99984L13.3327 11.6665M18.3327 9.99984C18.3327 14.6022 14.6017 18.3332 9.99935 18.3332C5.39698 18.3332 1.66602 14.6022 1.66602 9.99984C1.66602 5.39746 5.39698 1.6665 9.99935 1.6665C14.6017 1.6665 18.3327 5.39746 18.3327 9.99984Z"
          stroke={META_STROKE}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clip}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function CourseProjectsIcon({ className = "course-meta-icon", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M12.4167 4.08333C12.4167 3.30836 12.4167 2.92087 12.3315 2.60295C12.1003 1.74022 11.4264 1.06635 10.5637 0.835185C10.2458 0.75 9.85831 0.75 9.08333 0.75C8.30836 0.75 7.92087 0.75 7.60295 0.835185C6.74022 1.06635 6.06635 1.74022 5.83519 2.60295C5.75 2.92087 5.75 3.30836 5.75 4.08333M3.41667 15.75H14.75C15.6834 15.75 16.1501 15.75 16.5067 15.5683C16.8203 15.4086 17.0752 15.1536 17.235 14.84C17.4167 14.4835 17.4167 14.0168 17.4167 13.0833V6.75C17.4167 5.81658 17.4167 5.34987 17.235 4.99335C17.0752 4.67975 16.8203 4.42478 16.5067 4.26499C16.1501 4.08333 15.6834 4.08333 14.75 4.08333H3.41667C2.48325 4.08333 2.01654 4.08333 1.66002 4.26499C1.34641 4.42478 1.09144 4.67975 0.931656 4.99335C0.75 5.34987 0.75 5.81658 0.75 6.75V13.0833C0.75 14.0168 0.75 14.4835 0.931656 14.84C1.09144 15.1536 1.34641 15.4086 1.66002 15.5683C2.01654 15.75 2.48325 15.75 3.41667 15.75Z"
        stroke={META_STROKE}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CoursesPricingBar({ oldPrice, newPrice, scholarshipText }) {
  return (
    <ReachRim variant="pricing" className="courses-section-dark__pricing">
      <div className="courses-section-dark__pricing-info">
        <div className="courses-section-dark__prices">
          <span className="courses-section-dark__price-old">{oldPrice}</span>
          <span className="courses-section-dark__price-new">{newPrice}</span>
        </div>
        <p className="courses-section-dark__scholarship">{scholarshipText}</p>
      </div>
      <a href="#form-container" className="courses-section-dark__pricing-btn track-button">
        Request a Call Back
      </a>
    </ReachRim>
  );
}

export default function CoursesSectionDark() {
  useWebflowTabs();
  return (
    <>
      <section id="our-courses" className="courses-you-can-choose-sec courses-section-dark">
          <div className="courses-online-offline">
            <h2 className="h2-heading">Courses You Can Choose</h2>
            <div data-current="Tab 2" data-easing="ease" data-duration-in="300" data-duration-out="100" className="tabs-56 w-tabs">
              <div className="tabs-menu-239 w-tab-menu">
                <a href="#training-center-courses" data-w-tab="Tab 2" id="in-classroom-our-courses" className="tab-link-tab-1-23 track-button w-inline-block w-tab-link w--current">
                  <div>Training Center</div>
                </a>
                <a href="#online-courses" data-w-tab="Tab 1" id="online-our-courses" className="tab-link-tab-1-23 track-button w-inline-block w-tab-link">
                  <div>Online</div>
                </a>
              </div>
              <div className="tabs-content-49 w-tab-content">
              <div data-w-tab="Tab 1" className="w-tab-pane w--tab-active">
                  <div className="courses-section-dark__tab-panel">
                    <div className="courses-container-off-online">
                      <ReachRim variant="python-tc" className="main-card-courses-python">
                        <div className="left-of-main-card"><img src={COURSE_HEADER_ICONS.stack} loading="lazy" alt="" className="image-8128822646 course-card__icon" />
                          <div className="text-block-941288240437">COURSE 1</div>
                          <h3 className="heading-3671144">Python Full Stack with <span className="text-span-1790">GenAI</span></h3>
                          <div className="project-time-python">
                            <div className="div-block-1831980521448587"><CourseDurationIcon />
                              <div className="text-block-941288240435">6 months</div>
                            </div>
                            <div className="div-block-1831980521448587"><CourseProjectsIcon />
                              <div className="text-block-941288240435">10+ real time projects</div>
                            </div>
                          </div>
                          <div className="scroll-mobile-off-online">
                            <div className="left-side-move">
                              <HorizontalCourseLogoMarquee
                                items={COURSE_LOGOS_DARK.mobileFull}
                                labeled
                                direction="left"
                              />
                            </div>
                            <div className="mobile-python-mask"></div>
                          </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 280 1" fill="none" className="svg-in-mobile-hide">
                            <line y1="0.5" x2="280" y2="0.5" stroke="currentColor" strokeDasharray="6 6"></line>
                          </svg>
                        </div>
                        <div className="right-of-main-card">
                          <div className="up-side-courses">
                            <VerticalCourseLogoMarquee
                              items={COURSE_LOGOS_DARK.mernUp}
                              labeled
                              direction="up"
                            />
                          </div>
                          <div className="down-side-courses">
                            <VerticalCourseLogoMarquee
                              items={COURSE_LOGOS_DARK.mernDown}
                              labeled
                              direction="down"
                            />
                          </div>
                          <div className="python-mask-desktop"></div>
                        </div>
                      </ReachRim>
                      <ReachRim variant="java-tc" className="java-offline-card">
                        <div className="left-of-main-card"><img src={COURSE_HEADER_ICONS.java} loading="lazy" alt="" className="image-8128822646 course-card__icon" />
                          <div className="text-block-941288240437">COURSE 2</div>
                          <h3 className="java-fullstack-genai-head">Java Full Stack with <span className="text-span-1791">GenAI</span></h3>
                          <div className="project-time-python">
                            <div className="div-block-1831980521448587"><CourseDurationIcon />
                              <div className="text-block-941288240435">6 months</div>
                            </div>
                            <div className="div-block-1831980521448587"><CourseProjectsIcon />
                              <div className="text-block-941288240435">10+ real time projects</div>
                            </div>
                          </div>
                          <div className="scroll-mobile-off-online">
                            <div className="right-side-move">
                              <HorizontalCourseLogoMarquee
                                items={COURSE_LOGOS_DARK.mobileJava}
                                labeled
                                direction="right"
                              />
                            </div>
                            <div className="java-mobile-mask"></div>
                          </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 280 1" fill="none" className="svg-in-mobile-hide">
                            <line y1="0.5" x2="280" y2="0.5" stroke="currentColor" strokeDasharray="6 6"></line>
                          </svg>
                        </div>
                        <div className="right-of-main-card">
                          <div className="up-side-courses">
                            <VerticalCourseLogoMarquee
                              items={COURSE_LOGOS_DARK.mernUp}
                              labeled
                              direction="up"
                            />
                          </div>
                          <div className="down-side-courses">
                            <VerticalCourseLogoMarquee
                              items={COURSE_LOGOS_DARK.javaDown}
                              labeled
                              direction="down"
                            />
                          </div>
                          <div className="java-card-mask"></div>
                        </div>
                      </ReachRim>
                    </div>
                    <CoursesPricingBar
                      oldPrice="₹60,000"
                      newPrice="₹45,000 /-"
                      scholarshipText="Save up to ₹15,000 with Scholarship"
                    />
                  </div>
                </div>
                <div data-w-tab="Tab 2" className="w-tab-pane">
                  <div className="courses-section-dark__tab-panel">
                    <div className="courses-container-off-online">
                      <ReachRim variant="python-online" className="python-online-course">
                        <div className="left-of-main-card"><img src={COURSE_HEADER_ICONS.stack} loading="lazy" alt="" className="image-8128822646 course-card__icon" />
                          <div className="text-block-941288240437">COURSE 1</div>
                          <h3 className="python-fullstack-heading">MERN Full Stack</h3>
                          <div className="project-time-python">
                            <div className="div-block-1831980521448587"><CourseDurationIcon />
                              <div className="text-block-941288240435">8 months</div>
                            </div>
                            <div className="div-block-1831980521448587"><CourseProjectsIcon />
                              <div className="text-block-941288240435">10+ real time projects</div>
                            </div>
                          </div>
                          <div className="scroll-mobile-off-online">
                            <div className="left-side-move">
                              <HorizontalCourseLogoMarquee
                                items={COURSE_LOGOS_DARK.mobileFull}
                                labeled
                                direction="left"
                              />
                            </div>
                            <div className="mobile-python-mask"></div>
                          </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 280 1" fill="none" className="svg-in-mobile-hide">
                            <line y1="0.5" x2="280" y2="0.5" stroke="currentColor" strokeDasharray="6 6"></line>
                          </svg>
                        </div>
                        <div className="right-of-main-card">
                          <div className="up-side-courses">
                            <VerticalCourseLogoMarquee
                              items={COURSE_LOGOS_DARK.mernUp}
                              labeled
                              direction="up"
                            />
                          </div>
                          <div className="down-side-courses">
                            <VerticalCourseLogoMarquee
                              items={COURSE_LOGOS_DARK.mernDown}
                              labeled
                              direction="down"
                            />
                          </div>
                          <div className="python-mask-desktop"></div>
                        </div>
                      </ReachRim>
                      <ReachRim variant="java-online" className="java-online-card">
                        <div className="left-of-main-card"><img src={COURSE_HEADER_ICONS.java} loading="lazy" alt="" className="image-8128822646 course-card__icon" />
                          <div className="text-block-941288240437">COURSE 2</div>
                          <h3 className="java-fullstack-heading">Java Full Stack </h3>
                          <div className="project-time-python">
                            <div className="div-block-1831980521448587"><CourseDurationIcon />
                              <div className="text-block-941288240435">8 months</div>
                            </div>
                            <div className="div-block-1831980521448587"><CourseProjectsIcon />
                              <div className="text-block-941288240435">10+ real time projects</div>
                            </div>
                          </div>
                          <div className="scroll-mobile-off-online">
                            <div className="right-side-move">
                              <HorizontalCourseLogoMarquee
                                items={COURSE_LOGOS_DARK.mobileJava}
                                labeled
                                direction="right"
                              />
                            </div>
                            <div className="mobile-python-mask"></div>
                          </div><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 280 1" fill="none" className="svg-in-mobile-hide">
                            <line y1="0.5" x2="280" y2="0.5" stroke="currentColor" strokeDasharray="6 6"></line>
                          </svg>
                        </div>
                        <div className="right-of-main-card">
                          <div className="up-side-courses">
                            <VerticalCourseLogoMarquee
                              items={COURSE_LOGOS_DARK.mernUp}
                              labeled
                              direction="up"
                            />
                          </div>
                          <div className="down-side-courses">
                            <VerticalCourseLogoMarquee
                              items={COURSE_LOGOS_DARK.javaDown}
                              labeled
                              direction="down"
                            />
                          </div>
                          <div className="python-mask-desktop"></div>
                        </div>
                      </ReachRim>
                    </div>
                    <CoursesPricingBar
                      oldPrice="₹49,000"
                      newPrice="₹33,000 /-"
                      scholarshipText="Save up to ₹16,000 with Scholarship"
                    />
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </section>
    </>
  );
}
